<template>
  <v-radio-group
    row
    v-model="model"
    @change="updateValue"
    @click="focusRadio(model)"
  >
    <v-radio v-for="(radio, i) in radios" :key="i"
      :class="className"
      :color="color"
      :label="radio.text"
      :value="radio.value"
    />
  </v-radio-group>
</template>

<script>
export default {
  name: 'PosRadioGroup',
  props: {
    radios: { type: Array, default: () => ([]) },
    className: { type: String, default: 'v-radio-group-custom' },
    color: { type: String, default: 'primary' },
    disabled: { type: Boolean, default: false },
    value: { type: [Number, Boolean], default: false },
  },
  computed: {
    model: {
      get() { return this.value; },
      set() {},
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    },
    focusRadio(value) {
      this.$emit('focusRadio', value);
    }
  },
};
</script>
